import { render } from "./buy-order.vue?vue&type=template&id=4e8bb92c&scoped=true"
import script from "./buy-order.vue?vue&type=script&lang=js"
export * from "./buy-order.vue?vue&type=script&lang=js"

import "./buy-order.vue?vue&type=style&index=0&id=4e8bb92c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8bb92c"]])

export default __exports__